// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 777) return "static/js/recorder.ac35c1fd1.chunk.js";
	if (chunkId === 12) return "static/js/profiler.ac35c1fd1.chunk.js";
	if (chunkId === 31) return "static/js/31.ac35c1fd1.chunk.js";
	if (chunkId === 625) return "static/js/625.ac35c1fd1.chunk.js";
	if (chunkId === 160) return "static/js/160.ac35c1fd1.chunk.js";
	if (chunkId === 103) return "static/js/103.ac35c1fd1.chunk.js";
	if (chunkId === 177) return "static/js/177.ac35c1fd1.chunk.js";
	// return url for filenames based on template
	return undefined;
};